import { createContext, useMemo, useState } from 'react';

const ShopDataContext = createContext({});
const ShopCartContext = createContext({});

function ShopViewProvider({ children })
{
  // cart is a tempCart that holds quantity values for order sheet items until the user actually updates the cart
  // these quantities persist when switching between the grid and list views
  const [cart, setCart] = useState({});
  // data is the order sheet items
  const [data, setData] = useState([]);

  const dataValue = useMemo(() => ({ data, setData }), [data]);
  const cartValue = useMemo(() => ({ cart, setCart }), [cart]);

  return (
    <ShopDataContext.Provider value={dataValue}>
      <ShopCartContext.Provider value={cartValue}>
        {children}
      </ShopCartContext.Provider>
    </ShopDataContext.Provider>
  );
}

export { ShopDataContext, ShopCartContext, ShopViewProvider };
